// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body{background-color:#fff;padding:0}.main{width:1200px;margin:0 auto;height:100%}.el-pager li{border:1px solid #fff}.el-breadcrumb{height:42px;line-height:42px}.el-breadcrumb :last-child .el-breadcrumb__inner{font-size:12px;color:#0082f0!important}", ""]);
// Exports
module.exports = exports;
